<template>
  <v-card>
    <v-form @submit.prevent="submitAddDriver()" ref="addDriverForm">
      <v-card-title>
        <span class="headline">Add Driver {{isRequest || driver.request ? 'Request' : ''}}</span>
      </v-card-title>
      <v-container grid-list-lg>
        <v-layout wrap>
          <v-flex xs12 sm6>
            <v-text-field label="* Name" v-model="driver.name" :rules="nameRules"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Contact Email"
              v-model="driver.contactEmail"
              :rules="contactEmailRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Contact Phone"
              v-model="driver.contactPhone"
              :rules="contactPhoneRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete
              label="* Contractor"
              :items="activeContractors"
              v-model="driver.contractorId"
              item-text="name"
              item-value="id"
              :rules="contractorRules"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 v-if="!isRequest">
            <v-switch label="Request" v-model="driver.request"></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="primaryGrey" flat @click="close()">Cancel</v-btn>
        <v-btn
          :color="primaryNeutral"
          flat
          type="submit"
          :loading="addingDriver"
        >{{ isRequest || driver.request ? 'Create Request' : 'Add'}}</v-btn>
      </v-card-actions>
    </v-form>
    <inductions-panel
      :projects="projects"
      :discarding="discarding"
      @selectedChanged="onSelectedChanged"
      @selectedInductionsChanged="onSelectedInductionsChanged"
      @discard="discarding = false"
      isDriver
    ></inductions-panel>
  </v-card>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import DriverService from '@/services/requests/driverService'
import ContractorService from '@/services/requests/contractorService'

// MIXINS
import DriverValidation from '@/services/validation/driverValidation'
import getProjects from '@/services/mixins/getMasterFiles/getProjects'

// COMPONENTS
import DatePickerWrapper from '@/components/ui/datePickerWrapper'
import InductionsPanel from '@/components/ui/inductionsPanel'

export default {
  components: {
    DatePickerWrapper,
    InductionsPanel,
  },
  mixins: [DriverValidation, getProjects],
  props: {
    parentStore: {
      type: String,
      default: 'drivers',
    },
    isRequest: Boolean,
  },
  data() {
    return {
      driver: {
        name: '',
        contactEmail: '',
        contactPhone: '',
        contractorId: '',
        request: false,
      },
      addingDriver: false,
      selectedProjects: [],
      allProjects: [],
      projectPanel: false,
      selectAllProjects: false,
      selectedInductions: {},
      inductionsChanged: false,
      projectColor: this.$store.state.global.pages.project.color,
      discarding: false,
    }
  },
  computed: {
    activeContractors: Store.getSet({
      store: 'contractors',
      prop: 'activeContractors',
    }),
  },
  mounted() {
    this.initInductions()
  },
  methods: {
    initInductions() {
      for (const project of this.projects) {
        this.allProjects.push(project.id)
        this.selectedInductions[project.id] = ''
      }
    },
    submitAddDriver() {
      if (!this.$refs.addDriverForm.validate()) {
        this.snack({ text: 'Please correct form errors', color: 'red' })
        return
      }
      this.addDriver()
    },
    addDriver() {
      this.loading = true
      const inductions = []
      for (const projectId of this.selectedProjects) {
        inductions.push({
          projectId,
          number: this.selectedInductions[projectId],
        })
      }
      if (this.isRequest) this.driver.request = this.isRequest
      const postedDriver = { ...this.driver, inductions }
      DriverService.addDriver(postedDriver)
        .then((result) => {
          this.loading = false
          this.$store.commit('drivers/addToArrayState', {
            prop: 'drivers',
            value: result.data.result,
          })
          this.resetForm()
          this.snack({ color: 'green', text: 'Driver was added' })
          this.close()
          this.$emit('closeRequest')
        })
        .catch((err) => {
          this.snackError()
          this.addingDriver = false
          console.log(err)
        })
    },
    resetForm() {
      this.driver.name = ''
      this.driver.contactEmail = ''
      this.driver.contactPhone = ''
      this.driver.contractor = ''
      this.$refs.addDriverForm.resetValidation()
      this.selectedProjects = []
      this.initInductions()
    },
    close() {
      this.$emit('close')
    },
    onSelectedChanged(val) {
      this.selectedProjects = val
    },
    onSelectedInductionsChanged(val) {
      console.log('SELECTED INDUCTIONS CHANGED')
      this.selectedInductions = val
    },
  },
}
</script>

<style>
</style>
